import { render, staticRenderFns } from "./AlcoholAndHealth.vue?vue&type=template&id=74eb40ee&scoped=true&lang=true"
import script from "./AlcoholAndHealth.vue?vue&type=script&lang=js"
export * from "./AlcoholAndHealth.vue?vue&type=script&lang=js"
import style0 from "./AlcoholAndHealth.vue?vue&type=style&index=0&id=74eb40ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eb40ee",
  null
  
)

export default component.exports